// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"b05c531f","38":"530c5990","274":"8ca4967b","275":"ad3e5a8b","397":"e1b5d335","428":"1e23688d","488":"79faad5e","497":"0a0d2fa9","535":"772a148e","608":"c55eccc4","830":"b395b2d8","942":"dae3a193","978":"7c68557e"}[chunkId] + ".chunk.js";
};